//@ts-check
import { useState, useMemo } from "react"
import { GeneralReportProvider } from "../../context/report-generator/GeneralReport"
import { useIntl } from "react-intl"
import GeneralReportForm from "./GeneralReportForm"
import { PitchDetailReportProvider } from "../../context/report-generator/PitchDetailReport"
import { MatchReportProvider } from "../../context/report-generator/MatchReport"
import PitchDetailReportForm from "./PitchDetailReportForm"
import MatchReportForm from "./MatchReportForm"
import { useSearchParams } from "react-router"

export default function PdfGeneratorForm({ ...props }) {
    const { formatMessage } = useIntl()

    const [params] = useSearchParams()

    const REPORT_TYPES = useMemo(() => [
        {
            value: 1,
            label: formatMessage({ id: 'general' }),
            tooltip: formatMessage({ id: 'generalReportTooltip' }),
        },
        {
            value: 2,
            label: formatMessage({ id: 'pitchDetail' }),
            tooltip: formatMessage({ id: 'pitchDetailReportTooltip' }),
        },
        {
            value: 3,
            label: formatMessage({ id: 'matchReport' }),
            tooltip: formatMessage({ id: 'matchReportTooltip' }),
        },
    ], [])

    const initMatchReportDefault = !!params.get('matchEvent')

    const [reportType, setReportType] = useState(initMatchReportDefault ? REPORT_TYPES[2] : REPORT_TYPES[0])

    return reportType.value === 1 ?
        <GeneralReportProvider>
            <GeneralReportForm
                reportType={reportType}
                setReportType={setReportType}
                reportTypeOptions={REPORT_TYPES}
            />
        </GeneralReportProvider>
        :
        reportType.value === 2 ?
            <PitchDetailReportProvider>
                <PitchDetailReportForm
                    reportType={reportType}
                    setReportType={setReportType}
                    reportTypeOptions={REPORT_TYPES}
                />
            </PitchDetailReportProvider>
            :
            reportType.value === 3 ?
                <MatchReportProvider>
                    <MatchReportForm
                        reportType={reportType}
                        setReportType={setReportType}
                        reportTypeOptions={REPORT_TYPES}
                    />
                </MatchReportProvider>
                :
                null
}